import { useMemo } from 'react'
import { type Ordinances, type Ordinance } from '@fs/zion-tree-types'
import getDisplayableOrdinances from './getDisplayableOrdinances'
import { type PrimaryParents } from '../../../data-service/usePrimaryParents'

export default function useDisplayableOrdinances(
  ordinances: Ordinances | undefined,
  primaryParents: PrimaryParents | undefined
): Ordinance[] {
  return useMemo(() => getDisplayableOrdinances(ordinances, primaryParents), [ordinances, primaryParents])
}
